import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import './design/global.css';
import './i18n';
// Kesicilerin (Authorization, x-device-id, 401 -> yenileme) MEVCUT axios
// ornegine takilmasi bu import'un YAN ETKISI. Import edilmezse istekler
// jetonsuz gider ve hata ilk 401'de degil, sessiz bir 403 olarak gorunur.
import './api/client';
import { initTheme } from './design/theme';
import { queryClient } from './lib/queryClient';
import { router } from './app/router';
import { useSessionStore } from './auth/session.store';
import { ToastViewport } from './ui';

// data-theme'i index.html'deki satir ici betik ZATEN yazdi; burada yalniz sistem
// temasi dinleyicisi baglanir ve depo ile belge senkron tutulur.
initTheme();

// SOGUK ACILIS: `/v1/me` ucu YOK, bu yuzden oturum kalici ozetten canlandirilir
// ve sessiz bir yenileme ile dogrulanir. Beklenmez — korumalar `hydrating`
// durumunda kendi bekleme ekranini gosterir.
void useSessionStore.getState().bootstrap();

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root bulunamadi — index.html bozulmus olabilir.');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ToastViewport />
    </QueryClientProvider>
  </StrictMode>,
);
